// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./en/translation.json";
import translationDE from "./de/translation.json";
import translationSK from "./sk/translation.json";
import translationUA from "./ua/translation.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  sk: {
    translation: translationSK,
  },
  ua: {
    translation: translationUA,
  },
};

i18n 
  .use(LanguageDetector) // detect user language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({ // initialize i18n
    resources,
    fallbackLng: "en", // use English if user language is not available
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
